import React from 'react';
import './BulkActionBar.css';

/**
 * BulkActionBar - Eine zentrale Komponente für Mehrfachauswahl-Aktionen.
 * 
 * @param {Object} props
 * @param {number} props.selectedCount - Anzahl der ausgewählten Elemente.
 * @param {Function} props.onClearSelection - Callback zum Aufheben der Auswahl.
 * @param {Array} props.actions - Liste von Aktionen [{ label, icon, onClick, variant }].
 */
export default function BulkActionBar({ selectedCount, onClearSelection, actions = [], hideSelectionText = false }) {
    if (selectedCount === 0) return null;

    return (
        <div className="bulk-action-bar">
            <div className="bulk-action-bar-content">
                <div className="bulk-selection-info">
                    <button 
                        className="btn-close-selection" 
                        onClick={onClearSelection}
                        title="Auswahl aufheben"
                    >
                        ✕
                    </button>
                    {!hideSelectionText && <span className="selection-count">{selectedCount} ausgewählt</span>}
                </div>
                <div className="bulk-actions">
                    {actions.map((action, index) => (
                        action.render ? action.render() : (
                            <button
                                key={index}
                                className={`btn-bulk-action ${action.variant || 'secondary'}`}
                                onClick={action.onClick}
                            >
                                {action.icon && <span className="btn-icon">{action.icon}</span>}
                                {action.label}
                            </button>
                        )
                    ))}
                </div>
            </div>
        </div>
    );
}
